export default __webpack_public_path__ + "static/Temp_Lobby-2071be1a3d1480ebf853a8c081939880.webp";